import * as React from 'react';
import { SingleValueComponent, Validation } from 'ui/common';
import styles from './toggle-button.scss';
import {
  SecondaryValue,
  ToggleActionButton,
  getButtonText,
  getCurrentButtonIcon,
  getSignedStyles,
  getValidationErrorStyle,
  getValueComponent
} from './toggle-button-helpers';

export interface ToggleButtonProps extends SingleValueComponent<Date | string | number>{
  textLabel: string;
  textLabelToggle: string;
  valueResolver: () => Date | string | number;
  buttonIcon?: React.ReactNode;
  buttonIconToggle?: React.ReactNode;
  secondaryValue?: React.ReactNode;
  iconOnlyWhenActive?: boolean; //When true, only the icon is rendered once the button is toggled (value is set),
  bgColorOverride?: boolean;
  hideUndoEgress?: boolean;
}

export const ToggleButton: React.FC<ToggleButtonProps> = props => {

  const {
    value,
    valueResolver,
    readOnly,
    textLabel,
    textLabelToggle,
    buttonIcon,
    buttonIconToggle,
    componentId,
    className,
    onChange,
    secondaryValue,
    validation,
    iconOnlyWhenActive,
    hideUndoEgress,
    bgColorOverride = false
  } = props;

  const buttonText = getButtonText(value, textLabel, textLabelToggle);

  const handleChange = () => {
    if (!onChange || !valueResolver) {
      return;
    }

    onChange(value === undefined ? valueResolver() : undefined);
  };

  const ValueComponent:any = getValueComponent(value);
  const currentButtonIcon = getCurrentButtonIcon(value, buttonIcon, buttonIconToggle);
  const signedStyles = getSignedStyles(value);
  const validationErrorStyle = getValidationErrorStyle(validation);
  const hasValidationErrors = !!validationErrorStyle;
  const bgColorInlineStyle = !bgColorOverride ? 'has-bg-color' : undefined;

  return (
    <div className={`form-group ${className}`} id={componentId}>
      <div className={`${styles.toggleWrapper} ${signedStyles} ${validationErrorStyle}`}>
        <div>
          <ValueComponent {...props} componentId={`${componentId}_value`} className={bgColorInlineStyle} value={value} showStacked={true}/>
          <SecondaryValue show={!!value} text={secondaryValue} />
        </div>
        <ToggleActionButton
          value={value}
          componentId={componentId}
          className={className}
          readOnly={readOnly}
          hideUndoEgress={hideUndoEgress}
          iconOnlyWhenActive={iconOnlyWhenActive}
          buttonText={buttonText}
          icon={currentButtonIcon}
          onClick={handleChange}
        />
      </div>
      {hasValidationErrors && <Validation {...validation}/>}       
    </div>);
};
